import { createSelector } from 'reselect';
import { initialState } from './reducer';
import { NAMESPACE } from './constants';

const selectInitWebchatDomain = state => state[NAMESPACE] || initialState;

const selectWebchatConfigUserId = () =>
    createSelector(selectInitWebchatDomain, state => state.response.userId);

const selectWebchatConfigChatId = () =>
    createSelector(selectInitWebchatDomain, state => state.response.chatId);

const selectWebchatConfigAlias = () =>
    createSelector(selectInitWebchatDomain, state => state.response.alias);

const selectWebchatConfigSecureKey = () =>
    createSelector(selectInitWebchatDomain, state => state.response.secureKey);

const selectErrorCode = () =>
    createSelector(selectInitWebchatDomain, state => state.errorCode);

export {
    selectWebchatConfigUserId,
    selectWebchatConfigChatId,
    selectWebchatConfigAlias,
    selectWebchatConfigSecureKey,
    selectErrorCode,
};
